import {ENUM} from '../../core/enum/enum';
import { environment } from '../../../environments/environment';

export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon2-architecture-and-city',
					page: '/dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Reports',
					bullet: 'dot',
					root: true,
					translate: 'REPORTS.TITLE',
					icon: 'flaticon2-list-2',
					submenu: [
						{
							title: 'Recent Drivers',
							translate: 'REPORTS.RECENT_DRIVERS.TITLE',
							page: '/reports/recent-drivers'
						},
						{
							title: 'Recent Cars',
							translate: 'REPORTS.RECENT_CARS.TITLE',
							page: '/reports/recent-cars'
						},
					]
				},
				{
					title: 'Live Queue Statistics',
					bullet: 'dot',
					root: true,
					translate: 'LIVE_QUEUE_STATISTICS.TITLE',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.ADMIN],
					submenu: [
						{
							title: 'Car Count',
							translate: 'LIVE_QUEUE_STATISTICS.COUNT_TITLE',
							page: '/live-queue-statistics/liveQueueCount'
						},
						{
							title: 'Car Count By Area',
							translate: 'LIVE_QUEUE_STATISTICS.CAR_COUNT_BY_AREA_TITLE',
							page: '/live-queue-statistics/carsCountByArea'
						},
						{
							title: 'Accepted Requests',
							translate: 'LIVE_QUEUE_STATISTICS.ACCEPTED_REQUESTS_TITLE',
							page: '/live-queue-statistics/acceptedRequests'
						},
						{
							title: 'Payments',
							translate: 'SHIFT_MANAGEMENT.SHIFTS.PAYMENT_LIST.TITLE',
							page: '/live-queue-statistics/payments'
						},
						{
							title: 'Drivers Requests Rejected',
							translate: 'LIVE_QUEUE_STATISTICS.DRIVERS_REQUESTS_REJECTED_TITLE',
							page: '/live-queue-statistics/driversRequestsRejected'
						},
						{
							title: 'Live queue actions',
							translate: 'LIVE_QUEUE_STATISTICS.LIVE_QUEUE_ACTIONS_TITLE',
							page: '/live-queue-statistics/liveQueueActions'
						},
						{
							title: 'Payment Summary',
							translate: 'LIVE_QUEUE_STATISTICS.PAYMENT_TITLE',
							page: '/live-queue-statistics/paymentSummary'
						},
					]
				},
				{
					title: 'Areas List',
					page: '/area-management/areas',
					translate: 'AREA_MANAGEMENT.AREAS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-squares',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Companies',
					page: '/company-management/companies',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-buildings',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Companies Balances',
					page: '/company-management/company-balance',
					translate: 'COMPANY_MANAGEMENT.COMPANY_BALANCE.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Company Cars',
					page: '/company-management/company-cars',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.COMPANY_CARS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-delivery-truck',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Cars List',
					page: '/company-management/cars',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.CARS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-truck',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Drivers List',
					page: '/company-management/drivers',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.DRIVERS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-users',
					roles:[ENUM.roles.ADMIN, ENUM.roles.OPERATION]
				},
				{
					title: 'Barriers List',
					page: '/queue-management/barriers',
					translate: 'QUEUE_MANAGEMENT.BARRIER.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-files-and-folders',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Queues List',
					page: '/queue-management/queues',
					translate: 'QUEUE_MANAGEMENT.QUEUES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-files-and-folders',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Request List',
					page: '/queue-management/requests',
					translate: 'QUEUE_MANAGEMENT.REQUESTS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-car',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Live Queues',
					page: '/queue-management/live-queues',
					translate: 'QUEUE_MANAGEMENT.LIVE_QUEUES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-dashboard',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Shift List',
					page: '/cashier-management/shifts',
					translate: 'SHIFT_MANAGEMENT.SHIFTS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-soft-icons',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Places List',
					page: '/company-management/places',
					translate: 'COMPANY_MANAGEMENT.PLACES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-squares-4',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Lookup Managment',
					bullet: 'dot',
					root: true,
					translate: 'LOOKUP_MANAGEMENT.TITLE',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.ADMIN],
					submenu: [
						{
							title: 'Car Color',
							translate: 'LOOKUP_MANAGEMENT.COLOR.TITLE',
							page: '/lookup-management/color'
						},
						{
							title: 'Car Mnufacturer',
							translate: 'LOOKUP_MANAGEMENT.MANUFACTURER.TITLE',
							page: '/lookup-management/manufacturer'
						},
						{
							title: 'Car Model',
							translate: 'LOOKUP_MANAGEMENT.MODEL.TITLE',
							page: '/lookup-management/model'
						},
						{
							title: 'Place Types',
							translate: 'LOOKUP_MANAGEMENT.PLACE_TYPES.TITLE',
							page: '/lookup-management/place-types'
						},
					]
				}
			]
		},
	};
	public financial: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Shift List',
					page: '/cashier-management/shifts',
					translate: 'SHIFT_MANAGEMENT.SHIFTS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-soft-icons',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Companies Balances',
					page: '/company-management/company-balance',
					translate: 'COMPANY_MANAGEMENT.COMPANY_BALANCE.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list',
					roles:[ENUM.roles.ADMIN, ENUM.roles.FINANCIAL]
				},
				{
					title: 'Drivers List',
					page: '/company-management/drivers',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.DRIVERS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-users',
					roles:[ENUM.roles.ADMIN, ENUM.roles.FINANCIAL, ENUM.roles.OPERATION]
				},
				{
					title: 'Live Queue Statistics',
					bullet: 'dot',
					root: true,
					translate: 'LIVE_QUEUE_STATISTICS.TITLE',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.ADMIN, ENUM.roles.AIRPORT],
					submenu: [
						{
							title: 'Car Count',
							translate: 'LIVE_QUEUE_STATISTICS.COUNT_TITLE',
							page: '/live-queue-statistics/liveQueueCount'
						},
						{
							title: 'Car Count By Area',
							translate: 'LIVE_QUEUE_STATISTICS.CAR_COUNT_BY_AREA_TITLE',
							page: '/live-queue-statistics/carsCountByArea'
						},
						{
							title: 'Accepted Requests',
							translate: 'LIVE_QUEUE_STATISTICS.ACCEPTED_REQUESTS_TITLE',
							page: '/live-queue-statistics/acceptedRequests'
						},
						{
							title: 'Payments',
							translate: 'SHIFT_MANAGEMENT.SHIFTS.PAYMENT_LIST.TITLE',
							page: '/live-queue-statistics/payments'
						},
						{
							title: 'Drivers Requests Rejected',
							translate: 'LIVE_QUEUE_STATISTICS.DRIVERS_REQUESTS_REJECTED_TITLE',
							page: '/live-queue-statistics/driversRequestsRejected'
						},
						{
							title: 'Live queue actions',
							translate: 'LIVE_QUEUE_STATISTICS.LIVE_QUEUE_ACTIONS_TITLE',
							page: '/live-queue-statistics/liveQueueActions'
						},
						{
							title: 'Payment Summary',
							translate: 'LIVE_QUEUE_STATISTICS.PAYMENT_TITLE',
							page: '/live-queue-statistics/paymentSummary'
						},
					]
				},		
			]
		}
	};

	public airport: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'flaticon2-architecture-and-city',
					page: '/dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Reports',
					bullet: 'dot',
					root: true,
					translate: 'REPORTS.TITLE',
					icon: 'flaticon2-list-2',
					submenu: [
						{
							title: 'Recent Drivers',
							translate: 'REPORTS.RECENT_DRIVERS.TITLE',
							page: '/reports/recent-drivers'
						},
						{
							title: 'Recent Cars',
							translate: 'REPORTS.RECENT_CARS.TITLE',
							page: '/reports/recent-cars'
						},
					]
				},
				{
					title: 'Shift List',
					page: '/cashier-management/shifts',
					translate: 'SHIFT_MANAGEMENT.SHIFTS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-soft-icons',
					roles:[ENUM.roles.ADMIN]
				},
				{
					title: 'Live Queue Statistics',
					bullet: 'dot',
					root: true,
					translate: 'LIVE_QUEUE_STATISTICS.TITLE',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.ADMIN, ENUM.roles.AIRPORT],
					submenu: [
						{
							title: 'Car Count',
							translate: 'LIVE_QUEUE_STATISTICS.COUNT_TITLE',
							page: '/live-queue-statistics/liveQueueCount'
						},
						{
							title: 'Car Count By Area',
							translate: 'LIVE_QUEUE_STATISTICS.CAR_COUNT_BY_AREA_TITLE',
							page: '/live-queue-statistics/carsCountByArea'
						},
						{
							title: 'Accepted Requests',
							translate: 'LIVE_QUEUE_STATISTICS.ACCEPTED_REQUESTS_TITLE',
							page: '/live-queue-statistics/acceptedRequests'
						},
						{
							title: 'Payments',
							translate: 'SHIFT_MANAGEMENT.SHIFTS.PAYMENT_LIST.TITLE',
							page: '/live-queue-statistics/payments'
						},
						{
							title: 'Drivers Requests Rejected',
							translate: 'LIVE_QUEUE_STATISTICS.DRIVERS_REQUESTS_REJECTED_TITLE',
							page: '/live-queue-statistics/driversRequestsRejected'
						},
						{
							title: 'Live queue actions',
							translate: 'LIVE_QUEUE_STATISTICS.LIVE_QUEUE_ACTIONS_TITLE',
							page: '/live-queue-statistics/liveQueueActions'
						},
						{
							title: 'Payment Summary',
							translate: 'LIVE_QUEUE_STATISTICS.PAYMENT_TITLE',
							page: '/live-queue-statistics/paymentSummary'
						},
					]
				},				
				{
					title: 'Live Queues',
					page: '/queue-management/live-queues',
					translate: 'QUEUE_MANAGEMENT.LIVE_QUEUES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-dashboard',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION,ENUM.roles.AIRPORT]
				},
			]
		}
	};

	public cashier: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{section: 'Cashier'},
				{
					title: 'Cashier',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-browser-2',
					submenu: [
						{
							title: 'Home',
							page: '/cashier/home'
						}
					]
				}
			]
		},
	};

	public suprovisor: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Cars List',
					page: '/company-management/cars',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.CARS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-truck',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Drivers List',
					page: '/company-management/drivers',
					translate: 'COMPANY_MANAGEMENT.COMPANIES.DRIVERS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-users',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Queues List',
					page: '/queue-management/queues',
					translate: 'QUEUE_MANAGEMENT.QUEUES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-files-and-folders',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Request List',
					page: '/queue-management/requests',
					translate: 'QUEUE_MANAGEMENT.REQUESTS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon-car',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Live Queues',
					page: '/queue-management/live-queues',
					translate: 'QUEUE_MANAGEMENT.LIVE_QUEUES.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-dashboard',
					roles:[ENUM.roles.ADMIN,ENUM.roles.OPERATION]
				},
				{
					title: 'Live Queue Statistics',
					bullet: 'dot',
					root: true,
					translate: 'LIVE_QUEUE_STATISTICS.TITLE',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.ADMIN, ENUM.roles.AIRPORT],
					submenu: [
						{
							title: 'Car Count',
							translate: 'LIVE_QUEUE_STATISTICS.COUNT_TITLE',
							page: '/live-queue-statistics/liveQueueCount'
						},
						{
							title: 'Accepted Requests',
							translate: 'LIVE_QUEUE_STATISTICS.ACCEPTED_REQUESTS_TITLE',
							page: '/live-queue-statistics/acceptedRequests'
						},
						{
							title: 'Drivers Requests Rejected',
							translate: 'LIVE_QUEUE_STATISTICS.DRIVERS_REQUESTS_REJECTED_TITLE',
							page: '/live-queue-statistics/driversRequestsRejected'
						},
						{
							title: 'Live queue actions',
							translate: 'LIVE_QUEUE_STATISTICS.LIVE_QUEUE_ACTIONS_TITLE',
							page: '/live-queue-statistics/liveQueueActions'
						},
					]
				},		
			]
		},
	};

	public driver: any = {
		header: {
			self: {},
			items: []
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Balance',
					page: '/driver/balance',
					translate: 'DRIVER.BALANCE.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-wallet',
					roles:[ENUM.roles.COMPANY_DRIVER]
				},
				{
					title: 'Top Up',
					page: '/driver/checkout',
					translate: 'DRIVER.CHECKOUT.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-add',
					roles:[ENUM.roles.COMPANY_DRIVER]
				},
				{
					title: 'Transactions',
					page: '/driver/transactions',
					translate: 'DRIVER.TRANSACTIONS.TITLE',
					root: true,
					bullet: 'dot',
					icon: 'flaticon2-list-2',
					roles:[ENUM.roles.COMPANY_DRIVER]
				}
			]
		},
	};


	public get configs(): any {
		let role = localStorage.getItem(environment.role_id);
		if(+role == +ENUM.roles.ADMIN){
			return this.defaults;
		}else if(+role == +ENUM.roles.CASHIER){
            return this.cashier;
		}else if(+role == +ENUM.roles.FINANCIAL){
            return this.financial;
		}else if(+role == +ENUM.roles.OPERATION){
            return this.suprovisor;
		}else if(+role == +ENUM.roles.AIRPORT){
            return this.airport;
		}else if(+role == +ENUM.roles.COMPANY_DRIVER){
            return this.driver;
		}else{
			return {};
		}
	}
}
